<!--键值对展示组件-->
<template>
	<div class="columnsContentBody"> 
		<img :src="getLeftImage">
		<p class="columns">{{columns}}</p>
		<p class="content" @click="$emit('onClick')" style="color: white;">{{content}}</p>
	</div>
</template>

<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {
		},
		props: ["img", "columns","content"],
		data() {
			return {}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			getLeftImage(){
				return resourcesStore.getters.getResourcesByName('deyin/'+this.img+'.png')
			},
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
		},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.columnsContentBody{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.columns{
		font-size: 14px;
		margin-right: 30px;
		width: 20%;
		color: white;
	}
	.content{
		font-size: 14px;
		cursor: pointer;
	}
	.columnsContentBody img{
		margin-left: 2%;
		margin-right: 10px;
		width: 15px;
		height: 15px;
		padding: 2px 0px;
		margin-top: 1px;
		margin-bottom: 5px;
	}
</style>